module.exports = __webpack_public_path__ + "img/picture.fd6833b3.png";